import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';

import { useCustomToast } from 'hooks';
import {
  resendActivationLiteMail,
  resendActivationMail,
} from 'modules/account/features/singup/api';

export const useMutationResendActivationMail = (type?: string | null) => {
  const { t } = useTranslation();

  const { successToast, errorToast } = useCustomToast();

  const apiCall = type === 'renter' ? resendActivationLiteMail : resendActivationMail;

  return useMutation(apiCall, {
    onSuccess: () => successToast(t('Resend activation mail')),
    onError: () => errorToast(),
  });
};
